window.onload = function() {
    var button = document.querySelector("#cta-button");
  
    setInitialPosition();

    button.addEventListener('mouseover', function() {
      button.style.left = "0px"; 
    });
  
    button.addEventListener('mouseout', function() {
      setInitialPosition();  
    });
  
    window.addEventListener('resize', function() {
      setInitialPosition();  
    });

    function setInitialPosition() {
      if(window.innerWidth >= 1200) {
        button.style.left = "-256px";
      } else {
        button.style.left = "-160px";
      }
    }
  }